import { render, staticRenderFns } from "./AppSpinner.vue?vue&type=template&id=53bf7267&scoped=true"
import script from "./AppSpinner.vue?vue&type=script&lang=js"
export * from "./AppSpinner.vue?vue&type=script&lang=js"
import style0 from "./AppSpinner.vue?vue&type=style&index=0&id=53bf7267&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bf7267",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
